<template>
    <div class="maincontainer">
        <div class="maincolumn">
            <div class="Heading">
                <div class="left">
                    <h1 class="h1">
                        <span class="main">{{ trans("Example elements") }}</span>
                    </h1>
                </div>
            </div>
            <Widgets mode="grid" />
        </div>
    </div>
</template>

<script>
import {defineComponent, inject, watch, computed} from "vue";

import Widgets from "elements/widgets";

import Icon from "components/icon";
import trans from "helpers/_translation";

export default defineComponent({
    name: "dashboardMockup",
    components: {
        Icon,
        Widgets
    },
    setup() {
        return {
            trans
        }
    }
});
</script>
